import { CommonModule } from '@angular/common';
import { Component, inject} from '@angular/core';
import { CoreService } from '@common/services/core.service';
import { RouterLink, Router} from '@angular/router';
import { ROUTES_DASHBOARD } from '@common/enums/routes-dashboard.enum';
import { AuthService } from '@modules/auth/services/auth.service';
import { ROUTES_MAIN } from '@common/enums/routes-main.enum';
import { ROUTES_AUTH } from '@modules/auth/enums/routes-auth.enum';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { LoaderScreenService } from '@common/services/loader-screen.service';
import { ProfileService } from '@modules/profile/services/profile.service';
import { IProfileData } from '@modules/profile/interfaces/profile.interface';
import { UserImageComponent } from '../user-image/user-image.component';

@Component({
    selector: 'app-profile-options',
    imports: [
      CommonModule,
      RouterLink,
      ConfirmDialogModule,
      UserImageComponent
    ],
    providers: [
      ConfirmationService
    ],
    templateUrl: './profile-options.component.html',
    styleUrls: ['./profile-options.component.scss'],
})
export class ProfileOptionsComponent {
    private readonly coreService: CoreService = inject(CoreService);
    private readonly menuType: string = 'profile';
    private readonly authService: AuthService = inject(AuthService);
    private readonly router: Router = inject(Router);
    private readonly confirmationService: ConfirmationService = inject(ConfirmationService);
    private readonly loaderScreenService: LoaderScreenService = inject(LoaderScreenService);
    private readonly profileService: ProfileService = inject(ProfileService);

    toggleDropdownProfile: boolean = false;
    profile: IProfileData = {} as IProfileData;

    constructor () {}

    ngOnInit(): void {
      this.profile = this.profileService.profile;

      this.coreService.onMenuShow.subscribe((value) => {
        this.toggleDropdownProfile = value !== this.menuType ? false : !this.toggleDropdownProfile;
      })
    }

    toggleDropdown() {
      this.coreService.setMenuShow(this.menuType);
    }

    goToProfile(){
      return [ROUTES_DASHBOARD.PROFILE];
    }

    closeSession(){
      this.toggleDropdownProfile = false;
      this.confirmationService.confirm({
        message: '¿Estás seguro de cerrar sesión?',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        acceptButtonProps: {
          label: 'Cerrar sesión',
          severity: 'info',
        },
        rejectButtonProps: {
          label: 'Cancelar',
          severity: 'secondary',
        },
        accept: () => {
          this.loaderScreenService.show('Cerrando sesión');
          setTimeout(() => {
            this.authService.logout();
            this.router.navigate([ROUTES_MAIN.AUTH, ROUTES_AUTH.LOGIN]);
            this.loaderScreenService.hide();
          }, 2000);
        }
      });
    }

}
